import {Injectable, InjectionToken} from '@angular/core';
import {environment} from '../../../environments/environment.local';

export const ComplianceServiceToken =
  new InjectionToken<ComplianceService>('Compliance Service');


@Injectable()
export class ComplianceService {
  _notificationsAccepted: boolean;

  constructor() {
  }

  get notificationsAccepted(): boolean {
    return this._notificationsAccepted;
  }

  set notificationsAccepted(value: boolean) {
    if (typeof value === 'boolean') {
      this._notificationsAccepted = value;
    }
  }
}
